<script lang="ts">
  import OVIcon from "$components/+blocks/OVIcon/OVIcon.svelte";
  import cx from "classnames";
  import {
    EXPANSION_TIME_MS,
    PICKER_HEIGHT_DEFAULT,
    PICKER_HEIGHT_EXPANDED,
    PICKER_WIDTH_DEFAULT,
    PICKER_WIDTH_EXPANDED,
  } from "./EmojiPickerFull.svelte";
  import type { Placement } from "tippy.js";
  import { Collapse, Expand } from "$components/+blocks/OVIcon";

  export let placement: Placement = "top-start";
  export let expanded = false;
  export let pickerWidth: number;
  export let pickerHeight: number;
  export let virtualListContainerRef: HTMLDivElement;
  export let emojiPickerRef: HTMLDivElement;
</script>

<div
  class={cx(
    "absolute right-0 hidden translate-x-[40%] p-5 opacity-40 transition-all delay-[325ms] duration-300 group-hover:translate-x-[60%] group-hover:opacity-100 md:block",
    {
      "bottom-0 translate-y-[40%] group-hover:translate-y-[66%]": placement === "bottom-start",
      "top-0 translate-y-[-40%] group-hover:translate-y-[-66%]": placement === "top-start",
    }
  )}
>
  <button
    class="ov-focus w-full p-1 after:rounded-full"
    on:click={async () => {
      // we add a blur effect to the virtual list container to make the transition smoother
      virtualListContainerRef.classList.add("blur-[0.5px]");
      if (!expanded) {
        pickerWidth = PICKER_WIDTH_EXPANDED;
        pickerHeight = PICKER_HEIGHT_EXPANDED;
      } else {
        // we need wait for the transition to complete before resetting the width and height to avoid the content to be smaller than the container while transitioning
        emojiPickerRef.style.width = `${PICKER_WIDTH_DEFAULT}px`;
        emojiPickerRef.style.height = `${PICKER_HEIGHT_DEFAULT}px`;
        setTimeout(() => {
          pickerWidth = PICKER_WIDTH_DEFAULT;
          pickerHeight = PICKER_HEIGHT_DEFAULT;
        }, EXPANSION_TIME_MS);
      }
      setTimeout(() => {
        virtualListContainerRef.classList.remove("blur-[0.5px]");
      }, EXPANSION_TIME_MS);
      expanded = !expanded;
    }}
  >
    <div
      class={cx(
        "flex h-[24px] w-[24px] items-center justify-center rounded-full border-[0.5px] border-black/20 glossy-effect text-neutral-500 shadow-lg transition-all duration-300 hover:scale-[1.08] hover:border-black/40 hover:text-neutral-600 dark:border-white/20 dark:text-neutral-400 dark:hover:border-white/40 dark:hover:text-neutral-300",
        {
          "rotate-90": !expanded && placement === "bottom-start",
          "rotate-180": !expanded && placement === "top-start",
          "rotate-[270deg] delay-[125ms]": expanded && placement === "bottom-start",
          "rotate-[360deg] delay-[125ms]": expanded && placement === "top-start",
        }
      )}
    >
      {#if expanded}
        <OVIcon icon={Collapse} size="size-3" />
      {:else}
        <OVIcon icon={Expand} size="size-3" />
      {/if}
    </div>
  </button>
</div>
